import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { AttributeCheckbox } from '@eliadmin/core/src/components/categories/attributes/attribute-checkbox';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@eliadmin/core/src/components/ui/radio-group';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributeRadio({
  attribute,
  updateVariantValues,
  className = '',
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
  className?: string;
}) {
  const attrId = attribute.id;
  const settings = useGlobalStore(state => state.templateSettings);
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const replace = settings.category?.allow_only_one_value_in_radio_filter?.enabled;
  const setFilter = useCategoryStore(state => state.setFilter);

  if (!replace)
    return <AttributeCheckbox attribute={attribute} updateVariantValues={updateVariantValues} />;

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <RadioGroup
      value={String(valueAttribute ? valueAttribute.values[0]! : '')}
      className={cn('flex flex-col space-y-2', 'ea-attribute-radio', className)}
    >
      {sortedValues.map(value => (
        <div
          key={`attribute-${attribute.id}-value-${value.id}`}
          className={cn(
            'flex flex-row items-center space-x-2',
            'ea-attribute-radio__input-wrapper',
          )}
        >
          <RadioGroupItem
            key={`attribute-${attribute.id}-value-${value.id}`}
            value={String(value.id)}
            onClick={() => {
              setFilter({ selectedValue: { attribute, value }, replace: replace });
              updateVariantValues(attribute, value);
            }}
            type={'button'}
            className={cn(
              '',
              'ea-attribute-radio__item-input',
              `${valueAttribute?.values.includes(value.id) ? 'active' : ''}`,
            )}
          />
          <Label htmlFor={`attribute-${attribute.id}-value-${value.id}`}>{value.name}</Label>
        </div>
      ))}
    </RadioGroup>
  );
}
